import { LoadingBackground } from './LoadingBackground';
export default LoadingBackground;
